import { ExpandedEventInUrl } from '@app/enums';

import { AvailableCompetitionTabs } from './types';

// Keeping the tab information in the URL, but striping
// away expanded event information since changing tab
export function getQueryParamsAfterTabChange(
    query: Record<string, string | (string | null)[]>,
    tab: AvailableCompetitionTabs,
): Record<string, string | (string | null)[]> {
    const {
        [ExpandedEventInUrl.event]: _eventParam,
        [ExpandedEventInUrl.odd]: _oddParam,
        [ExpandedEventInUrl.type]: _typeParam,
        [ExpandedEventInUrl.sbValue]: _sbValueParam,
        ...queryWithoutEvent
    } = query;

    return {
        ...queryWithoutEvent,
        [ExpandedEventInUrl.competitionTab]: tab,
    };
}

export function getCompetitionRouteParams(rootGetters: Record<'navigation/route', { params: Record<string, string> }>): CategoryRouteParams {
    const { params } = rootGetters['navigation/route'];
    const { sportSlug, categorySlug, tournamentSlug } = params;

    return {
        sportSlug,
        categorySlug,
        tournamentSlug,
    };
}

type CategoryRouteParams = {
    sportSlug: string;
    categorySlug: string;
    tournamentSlug: string;
};
